import React from 'react';
import styled from 'styled-components';
import { ButtonTs, Throbber } from '@lt/components';

interface FlightsThrobberProps {
  onClick: () => void;
}

/** Троббер при подгрузке карточек перелетов */
export const FlightsThrobber = (props: FlightsThrobberProps): JSX.Element => {
  const isAvalible = 'IntersectionObserver' in window;
  const { onClick } = props;

  return isAvalible ? (
    <Throbber embed size={30} color="#444" />
  ) : (
    <LoadMoreButton size="flex" onClick={onClick}>
      Показать больше перелётов
    </LoadMoreButton>
  );
};

const LoadMoreButton = styled(ButtonTs)`
  padding: 0 10px;
`;
